import { lazy } from 'react';

const CompanyView = lazy(() => import('./CompanyView'));

export default CompanyView;
